import { Injectable } from '@angular/core';
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from '@angular/router';
import { ApiService } from '../../core/upgraded-providers';

import { HistoryDataSource } from './history.data-source';

@Injectable()
export class HistoryResolver implements Resolve<any> {

    constructor(
        private _apiService: ApiService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<any> {
        const dataSource = new HistoryDataSource(this._apiService);
        return dataSource.getData(0).toPromise();
    }
}
